import { CSSProperties } from "react";

import { NestedCSSProperties } from "@interfaces/types/styles.types";

export const rootContainerStyles: CSSProperties = {
  zIndex: 1000,
  backdropFilter: "blur(2px)",
  maxHeight: "100dvh",
  overflowY: "auto",
};

export const modalContainerStyles: CSSProperties | NestedCSSProperties = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  maxHeight: "100dvh",
  maxWidth: "100vw",
  fontSize: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
  transition: "opacity 0.15s linear",
  overflow: "hidden",
};

export const prioritizedView: CSSProperties = {
  zIndex: 1001,
};

export const topmostView: CSSProperties = {
  zIndex: 1002,
};

export const idleView: CSSProperties = {
  zIndex: 1003,
};

export const modalContentWrapperStyles: CSSProperties = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  maxHeight: "100dvh",
  maxWidth: "100vw",
  overflow: "hidden",
  padding: "8px",
  boxSizing: "border-box",
};
